var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-home"},[_c('div',{staticClass:"page-wrapper"},[_c('HomeMenu'),_c('v-main',[_c('router-view')],1),_c('HomeFooter')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }